var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.61 15.51C19.06 13.53 19.71 11.07 19.43 8.63C19.15 6.19 17.96 3.94 16.09 2.34C14.23 0.74 11.82 -0.09 9.37 0C6.91 0.1 4.58 1.12 2.85 2.85C1.11 4.59 0.09 6.92 0 9.38C-0.09 11.83 0.75 14.23 2.35 16.1C3.95 17.96 6.19 19.15 8.63 19.43C11.08 19.71 13.53 19.06 15.51 17.61L15.51 17.61C15.56 17.67 15.6 17.72 15.66 17.78L21.43 23.56C21.71 23.84 22.1 23.99 22.49 24C22.89 24 23.27 23.84 23.56 23.56C23.84 23.27 23.99 22.89 24 22.5C24 22.1 23.84 21.72 23.56 21.43L17.78 15.66C17.73 15.6 17.67 15.55 17.61 15.51L17.61 15.51ZM18 9.74C18 10.83 17.78 11.9 17.37 12.9C16.95 13.9 16.35 14.81 15.58 15.58C14.81 16.34 13.9 16.95 12.9 17.37C11.9 17.78 10.83 17.99 9.75 17.99C8.66 17.99 7.59 17.78 6.59 17.37C5.59 16.95 4.68 16.34 3.91 15.58C3.15 14.81 2.54 13.9 2.12 12.9C1.71 11.9 1.5 10.83 1.5 9.74C1.5 7.56 2.37 5.46 3.91 3.91C5.46 2.36 7.56 1.49 9.75 1.49C11.93 1.49 14.03 2.36 15.58 3.91C17.13 5.46 18 7.56 18 9.74Z",
    fill: "#00A03C",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearch);
export default __webpack_public_path__ + "static/media/ico_search.ccdafc69f8ce68e3383935f477ac98c3.svg";
export { ForwardRef as ReactComponent };